// validation/annualAssessment.schema.ts
import * as yup from 'yup';
import { PreLodgementChecklistFormValues } from '../types/preLodgementChecklist';

// --- Step 1: Personal Details ---
const clientInfoShape = {
  taxFinancialYear: yup
    .number()
    .typeError('Please select a tax financial year')
    .required('Please select a tax financial year'),
  citizenship: yup.string().required('Citizenship is required'),
  taxResidencyStatus: yup.string().required('Tax residency status is required'),
};

// --- Step 2: Property Income ---

const propertyIncomeShape = {
  propertyDisposalAnswer: yup
    .boolean()
    .nullable()
    .required('Please select Yes or No'),
  propertyDisposalNotes: yup.string().when('propertyDisposalAnswer', {
    is: true,
    then: (s) => s.required('Please provide details'),
    otherwise: (s) => s.optional(),
  }),
  propertyRefinanceAnswer: yup
    .boolean()
    .nullable()
    .required('Please select Yes or No'),
  propertyRefinanceNotes: yup.string().when('propertyRefinanceAnswer', {
    is: true,
    then: (s) => s.required('Please provide details'),
    otherwise: (s) => s.optional(),
  }),
  propertyPurchaseAnswer: yup
    .boolean()
    .nullable()
    .required('Please select Yes or No'),
  propertyPurchaseNotes: yup.string().when('propertyPurchaseAnswer', {
    is: true,
    then: (s) => s.required('Please provide details'),
    otherwise: (s) => s.optional(),
  }),
};

// --- Step 3: Other Income ---
const incomeShape = {
  incomeSource: yup.string().required('Income source is required'),
  employer: yup.string().trim().optional(),
  annualSalary: yup.string().required('Annual salary is required'),
  annualSalaryCurrency: yup
    .string()
    .required('Annual salary currency is required'),
  bonusesAndBenefits: yup.string().required('Bonuses and benefits is required'),
  bonusesAndBenefitsCurrency: yup
    .string()
    .required('Bonuses and benefits currency is required'),
  dividendAnswer: yup.boolean().nullable().required('Please select Yes or No'),
  cryptoAnswer: yup.boolean().nullable().required('Please select Yes or No'),
  shareDisposalAnswer: yup
    .boolean()
    .nullable()
    .required('Please select Yes or No'),
};

// --- Step 4: Future Plans ---
const futurePlansShape = {
  planningToBuyAnswer: yup
    .boolean()
    .nullable()
    .required('Please select Yes or No'),
  planningToBuyNotes: yup.string().when('planningToBuyAnswer', {
    is: true,
    then: (s) => s.required('Please provide details'),
    otherwise: (s) => s.optional(),
  }),
  propertySaleAnswer: yup
    .boolean()
    .nullable()
    .required('Please select Yes or No'),
  propertySaleNotes: yup.string().when('propertySaleAnswer', {
    is: true,
    then: (s) => s.required('Please provide details'),
    otherwise: (s) => s.optional(),
  }),
  repatriationAnswer: yup.boolean().nullable().optional(),
  repatriationDate: yup.string().when('repatriationAnswer', {
    is: true,
    then: (s) =>
      s
        .required('Please select both month and year')
        .matches(/^[a-z]+-\d{4}$/, 'Please select both month and year'),
    otherwise: (s) => s.optional(),
  }),
};

// --- Step 5: Additional Details ---
const reviewNotesShape = {
  additionalQuestions: yup.string().optional(),
  wantsMortgageReview: yup.boolean().nullable(),
};

// Combined schema — mirrors the combined type
export const preLodgementChecklistSchema: yup.ObjectSchema<PreLodgementChecklistFormValues> =
  yup.object({
    ...clientInfoShape,
    ...propertyIncomeShape,
    ...incomeShape,
    ...futurePlansShape,
    ...reviewNotesShape,
  }) as yup.ObjectSchema<PreLodgementChecklistFormValues>;
